import {
  ApiParams,
  BaseClient,
  IActionResponse,
  IActionResult,
  IPagedResult,
} from "../../../assets/utils/lib";
import { EventDto, SearchEventDto } from "../../dto";

export class EventClient extends BaseClient {
  routes = ["pophub", "Event"];

  async getEventAsync(id: string | undefined): Promise<EventDto> {
    const actions: string[] = ["GetEvent"];
    const params: ApiParams[] = [new ApiParams("id", id, true)];

    const result: EventDto = await this.getAsync<EventDto>(actions, params);
    return result;
  }

  async searchEventAsync(
    payload: SearchEventDto | undefined
  ): Promise<IPagedResult<EventDto>> {
    const actions: string[] = ["SearchEvents"];
    const result: IPagedResult<EventDto> = await this.postAsync<
      SearchEventDto,
      EventDto,
      IPagedResult<EventDto>
    >(actions, payload);
    return result;
  }

  async saveEventAsync(
    payload: EventDto | undefined
  ): Promise<IActionResult<EventDto>> {
    const actions: string[] = ["SaveEvent"];
    return await this.postAsync<EventDto>(actions, payload);
  }

  async deleteEventAsync(id?: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["DeleteEvent"];
    const params: ApiParams[] = [new ApiParams("id", id, true)];
    return await this.deleteAsync(actions, params);
  }
}
